import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=f2be7efc&viewBox=0%200%2068%2068"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports